import { stateName } from './constants';

const localState = state => state[stateName];

const uiState = state => localState(state).ui;

export const getShippingContactUiState = state => uiState(state).shippingContact;
export const getShippingContactSaveUiState = state => uiState(state).saveShippingContact;
export const getShippingContactDeleteUiState = state => uiState(state).deleteShippingContact;
export const getShippingContactConfigurationUiState = state => uiState(state).configuration;
export const getShippingContactConfiguration = state => localState(state).configuration;
export const getBuyerPhoneNumber = state => localState(state).buyerPhoneNumber;
export const getSellerPhoneNumber = state => localState(state).sellerPhoneNumber;
export const getShippingContactErrors = state => localState(state).errors;
export const getShippingContactFieldError = (state, field) => localState(state).errors.find(error => error.field === field);